// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    handleActions,
} from 'redux-actions';

import {
    GET_SERVICE_REQUEST_DATA_SUCCESS,
    UPDATE_DEVICE_CLAIM,
} from './actions';

const INITIAL_STATE: any[] = [];

export default handleActions({
    [GET_SERVICE_REQUEST_DATA_SUCCESS]: (state: any, action) => {
        if(Array.isArray(action.payload)){
            return action.payload;
        }

        return [ action.payload ];
    },
    [UPDATE_DEVICE_CLAIM]:(state: any, action) => ([ action.payload ]),
}, INITIAL_STATE);
